import React from 'react';
import './SectionHeader.css';
import { useTranslation } from 'react-i18next';


// `level` controls the semantic heading rank only; the visual size stays driven
// by `titleSize`/.title so the outline can change without the design changing.
// Defaults to 2 because a page's single h1 comes from its hero (CenterStage).
const SectionHeader = ({ title, subtitle, paragraph, titleSize, level = 2 }) => {
  const isMobile = window.innerWidth <= 768;
  const { t } = useTranslation();

  if (!titleSize) {
    titleSize = isMobile ? '1.8rem' : '3rem';
  } else if (isMobile) {
    titleSize = '1.8rem';
  }

  const Heading = `h${level}`;

  return (
    <div className="section-header">
      <Heading className="title" style={{ color: '#28588F', fontSize: titleSize }}>
        {(t(title))}
      </Heading>
      <p className="subtitle">{(t(subtitle))}</p>
      <p className="paragraph">{(t(paragraph))}</p>
    </div>
  );
};

export default SectionHeader;
